import { optionalCost } from "./capital-requirements"
import type { Cost } from "./util/cost"
import type { JsonHelper } from "./util/json"

export class MarginDryRunRejectedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "MarginDryRunRejectedError"
    Object.setPrototypeOf(this, MarginDryRunRejectedError.prototype)
  }
}

// The margin service's `margin/accounts/:n/dry-run`, not the order service's
// `accounts/:n/orders/dry-run` preflight (see order-dry-run.ts).
export interface MarginDryRunResult {
  readonly changeInMarginRequirement: Cost | null
  readonly changeInBuyingPower: Cost | null
  readonly currentBuyingPower: Cost | null
  readonly newBuyingPower: Cost | null
  readonly isolatedOrderMarginRequirement: Cost | null
  readonly isSpread: boolean
}

export function parseMarginDryRunResult(
  helper: JsonHelper
): MarginDryRunResult {
  return {
    changeInMarginRequirement: optionalCost(
      helper,
      "change-in-margin-requirement"
    ),
    changeInBuyingPower: optionalCost(helper, "change-in-buying-power"),
    currentBuyingPower: optionalCost(helper, "current-buying-power"),
    newBuyingPower: optionalCost(helper, "new-buying-power"),
    isolatedOrderMarginRequirement: optionalCost(
      helper,
      "isolated-order-margin-requirement"
    ),
    isSpread: helper.getBoolean("is-spread"),
  }
}
